import type {
  ArgusInstanceResponse,
  ArgusInstanceStatus,
  ArgusInstancesListResponse,
} from "../../types/argus";
import { useApiQuery } from "../use-api-query";

interface UseArgusInstancesOptions {
  limit?: number;
  offset?: number;
  instanceStatus?: ArgusInstanceStatus;
}

export function useArgusInstances(options: UseArgusInstancesOptions = {}) {
  const { limit = 20, offset = 0, instanceStatus } = options;

  const params = new URLSearchParams();
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  if (instanceStatus) params.set("instance_status", instanceStatus);

  const query = useApiQuery<ArgusInstancesListResponse>(
    `/client/argus/instances?${params.toString()}`,
  );

  return {
    ...query,
    instances: query.data?.data?.instances as ArgusInstanceResponse[] | undefined,
    total: query.data?.data?.total,
  };
}
